import { CSSObject } from '@chakra-ui/react';

export const LinkSignup: CSSObject = {
  display: 'none',
};
